/* This is an app environment file
	to setup API fetch URLs for both
	staging and production
*/
const Environment = {
	environment: {
		env: 'production',
		username: '',
		password: '',
		stagingURL:  'https://52.36.156.50',
		productionURL: 'https://sumomath.com',
		version: '5.0.0' //Jump release
	}
}

export default Environment;
